import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { configureStore } from '../../../store'
import App from './App'
// import { Container } from 'semantic-ui-react'
import ErrorMessageDialog from './ErrorMessageDialog'
import LoadingDialog from './LoadingDialog'

const store = configureStore()

export default () => (
    <Provider store={store}>
        <Router>
            <div className='height100'>
                {/* <Container> */}
                <App />
                {/* </Container> */}
                <ErrorMessageDialog />
                <LoadingDialog />
            </div>
        </Router>
    </Provider>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Root.prod.js